import React from "react";
import { Box, IconButton } from "@mui/material";

const IconWrapper = ({ children, iconButton, ...props }) => {
  return (
    (<Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="40px"
      height="40px"
      borderRadius="50%"
      border="1px solid grey"
      bgcolor="#FAFAFA"
      mr={1}
      {...props}
    >
      {iconButton ? (
        <IconButton style={{ color: "inherit" }} size="large">{children}</IconButton>
      ) : (
        children
      )}
    </Box>)
  );
};

export default IconWrapper;
